import { FunctionComponent } from 'react';

export const WidgetBackgroundGradient: FunctionComponent = () => {
  return <div className="w-full h-full bg-gradient-to-t from-white" />;
};
